import { render, staticRenderFns } from "./AutoScroll.vue?vue&type=template&id=73db2034&"
import script from "./AutoScroll.vue?vue&type=script&lang=js&"
export * from "./AutoScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports